module.exports = __webpack_public_path__ + "media/táng dèk táng pôo yài.ec902727.mp3";